import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import OutlookShell from './OutlookShell';
import OutlookSocketListener from './OutlookSocketListener';
import { setServiceEmail } from '../../../services/graphMailService';
import { bootstrapMail } from '../../../Slices/Thunk/graphMailThunks';
import { useDeltaSync } from './useDeltaSync';

export default function OutlookNew() {
  const userEmail = useSelector((s) => s?.loginUserInfo?.loginUserDetails?.email);
  const dispatch  = useDispatch();

  useEffect(() => {
    if (!userEmail) return;
    setServiceEmail(userEmail);
    localStorage.setItem('outlookUserEmail', userEmail);
    dispatch(bootstrapMail());
  }, [userEmail, dispatch]);

  useDeltaSync();

  return (
    <>
      <OutlookSocketListener userEmail={userEmail} />
      <OutlookShell userEmail={userEmail} />
    </>
  );
}
